import { FolderPlus, ClipboardList, Brain, CheckSquare } from 'lucide-react';

const steps = [
  {
    icon: FolderPlus,
    title: 'Créer un dossier',
    description: 'Saisissez le nom, CA, activité, et documents.',
  },
  {
    icon: ClipboardList,
    title: 'Répondre au prédiagnostic',
    description: 'Questions simples : Activité, Rentabilité, Risques, Compatibilité.',
  },
  {
    icon: Brain,
    title: 'Analyse financière & verdict',
    description: 'Extraction automatique + synthèse décisionnelle.',
  },
  {
    icon: CheckSquare,
    title: 'Décidez en toute clarté',
    description: 'Export PDF & next steps actionnables.',
  },
];

export function HowItWorksSection() {
  return (
    <section className="py-16 md:py-24 bg-card">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Comment ça marche
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            En 4 étapes simples, obtenez une analyse complète de votre projet de reprise.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-1/2 w-full h-0.5 bg-border" />
              )}
              
              <div className="relative flex flex-col items-center text-center">
                {/* Step number */}
                <div className="relative z-10 mb-4">
                  <div className="w-16 h-16 rounded-full bg-primary flex items-center justify-center">
                    <step.icon className="h-7 w-7 text-primary-foreground" />
                  </div>
                  <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-accent text-accent-foreground text-xs font-bold flex items-center justify-center">
                    {index + 1}
                  </span>
                </div>
                
                <h3 className="text-lg font-semibold mb-2">{step.title}</h3>
                <p className="text-sm text-muted-foreground">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
